import { numericFormatter } from 'react-number-format';

// See https://s-yadav.github.io/react-number-format/docs/numeric_format/
const defaultFormatterProp = {
  allowNegative: true,
  decimalScale: 0,
  decimalSeparator: '.',
  fixedDecimalScale: true,
  prefix: '',
  suffix: '',
  thousandSeparator: ',',
  thousandsGroupStyle: 'thousand',
};

const getNumericFormatterProps = (displayFormat) => {
  if (!displayFormat) return defaultFormatterProp;
  const parsed = displayFormat.toUpperCase().match(/([A-Z])(\d*)/);
  if (!parsed || parsed.length !== 3) return defaultFormatterProp;

  const decimalScale = Number(parsed[2]);

  switch (parsed[1]) {
    case 'P':
      return { ...defaultFormatterProp, decimalScale, suffix: '%' };

    case 'N':
      return { ...defaultFormatterProp, decimalScale };

    case 'F':
      return { ...defaultFormatterProp, decimalScale, thousandSeparator: '' };

    default:
      return defaultFormatterProp;
  }
};

const roundStringToDecimalPlaces = (strNumber, { decimalScale, suffix }) => {
  let number = parseFloat(strNumber);
  if (isNaN(number)) {
    return strNumber;
  }

  if (suffix === '%') number *= 100;

  const factor = Math.pow(10, decimalScale);
  const roundedNumber = Math.round(number * factor) / factor;

  return roundedNumber.toString();
};

export const format = (num, format) => {
  const props = getNumericFormatterProps(format);
  const rounded = roundStringToDecimalPlaces(num, props);
  const formatted = numericFormatter(rounded, props);

  return formatted;
};
